import React, { useEffect, useState } from "react";
import { Languages, FileText } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import FreeDownloadButton from "@/components/FreeDownloadButton";
import api from "@/lib/api";

export default function BilingualGuides() {
  const [guides, setGuides] = useState([]);
  useEffect(() => { api.get("/resources").then((r) => setGuides(r.data.filter((x) => x.bilingual))).catch(() => {}); }, []);
  if (!guides.length) return null;
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="bilingual-guides">
      {guides.map((g) => (
        <Card key={g.id} className="p-6 flex flex-col border-slate-200 hover:shadow-lg transition-shadow" data-testid={`bilingual-card-${g.id}`}>
          <div className="flex items-start justify-between mb-4">
            <div className="w-11 h-11 rounded-xl bg-teal-100 flex items-center justify-center"><Languages className="w-5 h-5 text-teal-700" /></div>
            <Badge className="bg-slate-900 text-white hover:bg-slate-900 font-semibold">English · 中文</Badge>
          </div>
          <h3 className="font-display text-lg font-bold text-slate-900">{g.title}</h3>
          <p className="text-sm text-slate-600 mt-2 flex-1">{g.description}</p>
          <div className="text-xs text-slate-400 mt-3 mb-4 flex items-center gap-1"><FileText className="w-3 h-3" /> {g.format} · Free</div>
          <FreeDownloadButton resource={g} />
        </Card>
      ))}
    </div>
  );
}
